import { useEffect, useState } from "react"

import { DATE_FORMAT } from "constants"
import { DatePicker } from "antd"
import { DATE_TIME_FORMAT } from "constants"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import locale from "antd/es/date-picker/locale/ar_EG"
import DateTime from "utils/dateTime"

const isDateOnlyFormat = (format) =>
  format &&
  format !== DATE_TIME_FORMAT &&
  !format.includes("HH") &&
  !format.includes("ss");

const parseFilterDate = (dateValue, valueFormat) => {
  if (!dateValue) return null;
  if (isDateOnlyFormat(valueFormat)) {
    const parsed = dayjs(dateValue, valueFormat, true);
    return parsed.isValid() ? parsed : null;
  }
  return DateTime.getDateAndTime(dateValue);
};

export default function SimpleDateFilter({
  onSelect,
  value: dateValue,
  valueFormat = DATE_TIME_FORMAT,
  label,
  disabledDate,
  picker,
  ...rest
}) {
  const [value, setValue] = useState()
  const { locale: appLanguage } = useSelector(state => state.app.configs)

  useEffect(() => {
    setValue(parseFilterDate(dateValue, valueFormat))
  }, [dateValue, valueFormat])

  return (
    <>
      <label className="d-block">{label}</label>
      <DatePicker
        format={picker !== "month" ? DATE_FORMAT : "MMMM-YYYY"}
        picker={picker}
        value={value}
        disabledDate={disabledDate}
        onChange={date => {
          setValue(date)
          onSelect(date, date ? DateTime.formatDate(date, valueFormat) : "")
        }}
        // locale={appLanguage === "en" ? [] : locale}
        {...rest}
      />
    </>
  )
}
